import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './pages/LoginForm';
import Dashboard from './pages/Dashboard';
import FrontDesk from './pages/FrontDesk';
import Guest from './pages/Guest';
import Rooms from './pages/Rooms';
import Deal from './pages/Deal';
import Rate from './pages/Rate';
import Reservations from './pages/Reservations';
import ThePrideReservations from './components/ThePrideReservations';

// --- PROTECTED ROUTE COMPONENT ---
// This checks if the user is logged in before rendering the page
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  if (!isLoggedIn) {
    // If not logged in, send them back to the login page
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/" element={<LoginForm />} />

      {/* Protected Routes - All wrapped with ProtectedRoute */}
      <Route 
        path="/dashboard" 
        element={<ProtectedRoute><Dashboard /></ProtectedRoute>} 
      />
      <Route 
        path="/reservations" 
        element={<ProtectedRoute><Reservations /></ProtectedRoute>} 
      />
      <Route 
        path="/front-desk" 
        element={<ProtectedRoute><FrontDesk /></ProtectedRoute>} 
      />
      <Route 
        path="/guest" 
        element={<ProtectedRoute><Guest /></ProtectedRoute>} 
      />
      <Route 
        path="/rooms" 
        element={<ProtectedRoute><Rooms /></ProtectedRoute>} 
      />
      <Route 
        path="/deal" 
        element={<ProtectedRoute><Deal /></ProtectedRoute>} 
      />
      <Route 
        path="/rate" 
        element={<ProtectedRoute><Rate /></ProtectedRoute>} 
      />
      <Route 
        path="/ThePrideReservations" 
        element={<ProtectedRoute><ThePrideReservations /></ProtectedRoute>} 
      />

      {/* Catch-all: Redirect any unknown routes to login or dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;